import { Flex } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';

import { useEvaluateNote } from '../dataHooks';
import { VIOLATION_STATUS } from '../types';

type ViewViolationAdminViewFooterProps = {
  violationNoteId: number;
  violationStatus: string;
  isPublishAllowed: boolean;
  onDeny: () => void;
  onCancel: () => void;
  onPublish: () => void;
};

export const ViewViolationAdminViewFooter = ({
  violationNoteId,
  violationStatus,
  isPublishAllowed,
  onDeny,
  onCancel,
  onPublish,
}: ViewViolationAdminViewFooterProps) => {
  const isPendingApproval = violationStatus === VIOLATION_STATUS.CREATED;
  const { mutate: evaluateNote, isLoading } = useEvaluateNote();

  const onApprove = () => {
    evaluateNote({ noteId: violationNoteId, body: { evaluation: 'APPROVED' } }, { onSuccess: onCancel });
  };

  return (
    <Flex
      justifyContent={isPendingApproval || isPublishAllowed ? 'space-between' : 'end'}
      h="72px"
      w="full"
      p="16px"
      bg="surface.F5F7F9"
      boxShadow="0px -1px 2px 0px #00000014"
    >
      <Button variant={isPendingApproval || isPublishAllowed ? 'transparentOutline' : 'filled'} onClick={onCancel}>
        {isPendingApproval ? 'Cancel' : 'Close'}
      </Button>
      {isPendingApproval && (
        <Flex gap="16px">
          <Button variant="transparentOutline" status="error" onClick={onDeny} disabled={isLoading}>
            Deny
          </Button>
          <Button variant="filled" onClick={onApprove} disabled={isLoading}>
            {isLoading ? 'Approving...' : 'Approve'}
          </Button>
        </Flex>
      )}
      {isPublishAllowed && (
        <Button variant="filled" onClick={onPublish} disabled={isLoading}>
          {isLoading ? 'Publishing...' : 'Publish'}
        </Button>
      )}
    </Flex>
  );
};
